import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c95a5b0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav__wrapper" }
const _hoisted_2 = ["onClick", "src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Mint")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Sold out ")
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("img", {
          onClick: navigate,
          class: "nav__logo",
          src: require('@/assets/logo.png'),
          alt: "Sacro"
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }),
    (_ctx.route.name == 'Home' && _ctx.currentMinted < _ctx.supply)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "home__mint",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/mint')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.route.name == 'Home' && _ctx.currentMinted >= _ctx.supply)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "home__sold",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open('https://opensea.io/collection/sacro-collection')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.route.name == 'Mint')
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/')))
        }, [
          _createElementVNode("img", {
            src: require('@/assets/close.svg'),
            alt: "Close"
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ]))
}